import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetNewsListSucceed, EGetNewsListActionType } from './types';
import { INewsList } from '../../../types/newsList';

export const getNewsListSucceed: (data: INewsList) => TGetNewsListSucceed = actionGenerator<
  EGetNewsListActionType.Succeed,
  INewsList
>(EGetNewsListActionType.Succeed);
